import { MarketingAudiences } from "./marketing/MarketingAudiences";
import { MarketingCompare } from "./marketing/MarketingCompare";
import { MarketingContact } from "./marketing/MarketingContact";
import { MarketingCta } from "./marketing/MarketingCta";
import { MarketingFeatures } from "./marketing/MarketingFeatures";
import { MarketingFooter } from "./marketing/MarketingFooter";
import { MarketingHeader } from "./marketing/MarketingHeader";
import { MarketingHero } from "./marketing/MarketingHero";
import { MarketingHowItWorks } from "./marketing/MarketingHowItWorks";
import { MarketingModules } from "./marketing/MarketingModules";
import { MarketingWhy } from "./marketing/MarketingWhy";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted/20">
      <MarketingHeader />
      <MarketingHero />
      <MarketingFeatures />
      <MarketingAudiences />
      <MarketingHowItWorks />
      <MarketingModules />
      <MarketingWhy />
      <MarketingCompare />
      <MarketingCta />
      <MarketingContact />
      <MarketingFooter />
    </div>
  );
};

export default HomePage;
